export const DEGREES = [
  {
    value: 'none',
    label: 'Aucun diplôme',
    estimatedMonthlySalary: 1140,
    firstJobSearchDuration: 12,
    unemploymentRate: 17,
  },
  // {
  //   value: 'cap-bep-ter',
  //   label: 'CAP-BEP Tertiaire',
  //   estimatedMonthlySalary: 1160,
  //   firstJobSearchDuration: 6,
  // },
  // {
  //   value: 'cap-bep-ind',
  //   label: 'CAP-BEP Industriel',
  //   estimatedMonthlySalary: 1300,
  //   firstJobSearchDuration: 6,
  // },
  // {
  //   value: 'bac-pro-tec-ter',
  //   label: 'Bac Pro / Techno tertiaire',
  //   estimatedMonthlySalary: 1200,
  //   firstJobSearchDuration: 6,
  // },
  // {
  //   value: 'bac-pro-tec-ind',
  //   label: 'Bac Pro / Techno industriel',
  //   estimatedMonthlySalary: 1400,
  //   firstJobSearchDuration: 6,
  // },
  {
    value: 'bac-gen',
    label: 'Bac Général',
    estimatedMonthlySalary: 1160,
    firstJobSearchDuration: 6,
    unemploymentRate: 10,
  },
  // {
  //   value: 'bac+2-ter',
  //   label: 'Bac+2 Tertiaire',
  //   estimatedMonthlySalary: 1400,
  //   firstJobSearchDuration: 4,
  // },
  // {
  //   value: 'bac+2-ind',
  //   label: 'Bac+2 Industriel',
  //   estimatedMonthlySalary: 1520,
  //   firstJobSearchDuration: 4,
  // },
  // {
  //   value: 'bac+2/3-soc',
  //   label: 'Bac+2/3 Santé social',
  //   estimatedMonthlySalary: 1730,
  //   firstJobSearchDuration: 3,
  // },
  // {
  //   value: 'pro-lic',
  //   label: 'Licence Professionnelle',
  //   estimatedMonthlySalary: 1600,
  //   firstJobSearchDuration: 4,
  // },
  // {
  //   value: 'bac+3/4-lit',
  //   label: 'Bac+3/4 LSH, gestion, droit',
  //   estimatedMonthlySalary: 1400,
  //   firstJobSearchDuration: 4,
  // },
  // {
  //   value: 'bac+3/4-sci',
  //   label: 'Bac+3/4 Maths, sc et tech. STAPS',
  //   estimatedMonthlySalary: 1560,
  //   firstJobSearchDuration: 4,
  // },
  // {
  //   value: 'bac+5-lit',
  //   label: 'Bac+5 LSH, gestion, droit',
  //   estimatedMonthlySalary: 1800,
  //   firstJobSearchDuration: 3,
  // },
  {
    value: 'bac+5-sci',
    label: 'Bac+5 Maths, sc et tech. STAPS',
    estimatedMonthlySalary: 2000,
    firstJobSearchDuration: 3,
    unemploymentRate: 5,
  },
  // {
  //   value: 'bac+5-com',
  //   label: 'Bac+5 École de commerce',
  //   estimatedMonthlySalary: 2150,
  //   firstJobSearchDuration: 3,
  // },
  // {
  //   value: 'bac+5-eng',
  //   label: 'Bac+5 École d\'ingénieurs',
  //   estimatedMonthlySalary: 2250,
  //   firstJobSearchDuration: 3,
  // },
  // {
  //   value: 'bac+7-doc-d',
  //   label: 'Bac+7 Doctorat (D)',
  //   estimatedMonthlySalary: 2440,
  //   firstJobSearchDuration: 3,
  // },
];

export const AVG_CAREER_YEARS = 42;
export const AVG_SALARY_YEARLY_INCREASE_GRADUATE = 1.1;
export const AVG_MONTHLY_LIVING_FEES_STUDENT = 600;
export const AVG_STUDIES_DURATION = 5;

export const SLIDER_DEFAULT_VALUE = 1000;
export const SLIDER_STEP = 100;
export const SLIDER_MIN_VALUE = SLIDER_STEP;
export const SLIDER_MAX_VALUE = 40000;



// WEBPACK FOOTER //
// ./src/constants.js